import { DoqFaceSvgProps } from '../types';

const DoqWaiting = ({ size, className }: DoqFaceSvgProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g clipPath="url(#clip0_189_10913)">
        <circle cx="100" cy="100" r="100" fill="#8800FF" />
        <mask
          id="mask0_189_10913"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="200"
          height="200"
        >
          <circle cx="100" cy="100" r="100" fill="white" />
        </mask>
        <g mask="url(#mask0_189_10913)">
          <rect x="50" y="75" width="100" height="125" fill="white" />
        </g>
        <path
          d="M88.75 115C91.5114 115 93.75 112.761 93.75 110C93.75 107.239 91.5114 105 88.75 105C85.9886 105 83.75 107.239 83.75 110C83.75 112.761 85.9886 115 88.75 115Z"
          fill="#2974C4"
        />
        <path
          d="M111.25 115C114.011 115 116.25 112.761 116.25 110C116.25 107.239 114.011 105 111.25 105C108.489 105 106.25 107.239 106.25 110C106.25 112.761 108.489 115 111.25 115Z"
          fill="#2974C4"
        />
        <ellipse
          cx="100.009"
          cy="43.7647"
          rx="4.01077"
          ry="4.01077"
          fill="#418B82"
        />
        <path
          d="M46.5318 87.7075C46.5318 63.109 70.5213 43.0963 100.009 43.0963C129.496 43.0963 153.486 63.1087 153.486 87.7075V98.5786L129.456 93.9705C110.074 90.2764 89.9432 90.2764 70.5613 93.9705L46.5318 98.5786V87.7075Z"
          fill="#500052"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.0413 104.707L48.0404 104.707C46.1714 105.5 44.0138 104.627 43.221 102.758C42.428 100.889 43.3006 98.7308 45.1699 97.9379L46.6056 101.323C45.1699 97.9379 45.1713 97.9373 45.1713 97.9373L45.1989 97.9256L45.2665 97.8973C45.3243 97.8732 45.4074 97.8387 45.515 97.7945C45.7303 97.7061 46.0437 97.579 46.4487 97.4187C47.2586 97.098 48.4354 96.6443 49.9271 96.1019C52.9089 95.0178 57.1568 93.5764 62.2517 92.1356C72.4052 89.2642 86.0856 86.3478 99.8746 86.3478C113.664 86.3478 127.344 89.2642 137.498 92.1356C142.592 93.5764 146.84 95.0178 149.822 96.1019C151.314 96.6443 152.491 97.098 153.301 97.4187C153.706 97.579 154.019 97.7061 154.234 97.7945C154.342 97.8387 154.425 97.8732 154.483 97.8973L154.55 97.9256L154.57 97.9338L154.578 97.9373C154.578 97.9373 154.579 97.9379 153.144 101.323L154.579 97.9379C156.449 98.7308 157.321 100.889 156.528 102.758C155.735 104.627 153.578 105.5 151.709 104.708L151.708 104.707L151.698 104.703L151.65 104.683C151.605 104.664 151.536 104.635 151.442 104.597C151.254 104.52 150.969 104.404 150.594 104.255C149.843 103.958 148.731 103.529 147.31 103.012C144.465 101.978 140.39 100.595 135.497 99.2112C125.674 96.4335 112.72 93.7009 99.8746 93.7009C87.0291 93.7009 74.075 96.4335 64.2526 99.2112C59.3595 100.595 55.2842 101.978 52.4397 103.012C51.0182 103.529 49.9062 103.958 49.1554 104.255C48.7801 104.404 48.4953 104.52 48.3074 104.597C48.2135 104.635 48.1438 104.664 48.0992 104.683L48.0511 104.703L48.0413 104.707Z"
          fill="#6DBCB4"
        />
        <path
          d="M98.3446 59.7001H93.825V64.2197H98.3446V59.7001Z"
          fill="white"
        />
        <path
          d="M107.386 68.7413H93.825V73.261H107.386V68.7413Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M96.8558 110.625C96.5332 115.857 92.1879 120 86.875 120C81.3522 120 76.875 115.523 76.875 110C76.875 104.477 81.3522 100 86.875 100C91.9745 100 96.1825 103.817 96.7976 108.75H103.202C103.817 103.817 108.025 100 113.125 100C118.648 100 123.125 104.477 123.125 110C123.125 115.523 118.648 120 113.125 120C107.812 120 103.467 115.857 103.144 110.625H96.8558ZM95 110C95 114.487 91.3623 118.125 86.875 118.125C82.3877 118.125 78.75 114.487 78.75 110C78.75 105.513 82.3877 101.875 86.875 101.875C91.3623 101.875 95 105.513 95 110ZM113.125 118.125C117.612 118.125 121.25 114.487 121.25 110C121.25 105.513 117.612 101.875 113.125 101.875C108.638 101.875 105 105.513 105 110C105 114.487 108.638 118.125 113.125 118.125Z"
          fill="#2974C4"
        />
        <g opacity="0.5">
          <path
            d="M60 151.875C60 151.53 60.2798 151.25 60.625 151.25H139.375C139.72 151.25 140 151.53 140 151.875V153.125C140 153.47 139.72 153.75 139.375 153.75H60.625C60.2798 153.75 60 153.47 60 153.125V151.875Z"
            fill="#2974C4"
          />
          <path
            d="M60 173.125C60 172.78 60.2798 172.5 60.625 172.5H139.375C139.72 172.5 140 172.78 140 173.125V174.375C140 174.72 139.72 175 139.375 175H60.625C60.2798 175 60 174.72 60 174.375V173.125Z"
            fill="#2974C4"
          />
          <path
            d="M60.625 161.25C60.2798 161.25 60 161.53 60 161.875V163.125C60 163.47 60.2798 163.75 60.625 163.75H139.375C139.72 163.75 140 163.47 140 163.125V161.875C140 161.53 139.72 161.25 139.375 161.25H60.625Z"
            fill="#2974C4"
          />
          <path
            d="M60 183.125C60 182.78 60.2798 182.5 60.625 182.5H139.375C139.72 182.5 140 182.78 140 183.125V184.375C140 184.72 139.72 185 139.375 185H60.625C60.2798 185 60 184.72 60 184.375V183.125Z"
            fill="#2974C4"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M99.3749 130C95.6736 130 92.442 127.989 90.7129 125L93.7847 125C95.158 126.534 97.1537 127.5 99.3749 127.5C101.596 127.5 103.592 126.534 104.965 125L108.037 125C106.308 127.989 103.076 130 99.3749 130Z"
          fill="#2974C4"
        />
      </g>
      <defs>
        <clipPath id="clip0_189_10913">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { DoqWaiting };
